import React from "react";

import { cn } from "@/utils/cn";

const spaces = {
  0: "space-y-0",
  [0.5]: "space-y-0.5",
  1: "space-y-1",
  [1.5]: "space-y-1.5",
  2: "space-y-2",
  [2.5]: "space-y-2.5",
  3: "space-y-3",
  4: "space-y-4",
  5: "space-y-5",
  6: "space-y-6",
  8: "space-y-8",
  9: "space-y-9",
  10: "space-y-10",
};

const justifyContentOptions = {
  between: "justify-between",
  center: "justify-center",
  end: "justify-end",
  around: "justify-around",
};

const alignItemsOptions = {
  top: "items-start",
  bottom: "items-end",
  center: "items-center",
  start: "items-start",
  end: "items-end",
};

interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Horizontal alignment of children. */
  alignItems?: keyof typeof alignItemsOptions;
  /** Extra class names on the element. */
  className?: string;
  /** Vertical alignment of children. */
  justifyContent?: keyof typeof justifyContentOptions;
  /** Size of the gap between elements. */
  space?: keyof typeof spaces;
  /** Whether to let the flexbox grow. */
  grow?: boolean;
  /** HTML element to use for container. */
  element?: keyof React.JSX.IntrinsicElements;
  ref?: React.Ref<HTMLDivElement>;
}

/** Vertical stack of child elements. */
const Stack = (props: StackProps) => {
  const {
    space,
    alignItems,
    justifyContent,
    className,
    grow,
    element = "div",
    ref,
    ...filteredProps
  } = props;

  const Elem = element as "div";

  return (
    <Elem
      {...filteredProps}
      ref={ref}
      className={cn(
        "flex flex-col",
        {
          // @ts-ignore
          [spaces[space]]: typeof space !== "undefined",
          // @ts-ignore
          [alignItemsOptions[alignItems]]: typeof alignItems !== "undefined",
          // @ts-ignore
          [justifyContentOptions[justifyContent]]:
            typeof justifyContent !== "undefined",
          grow: grow,
        },
        className,
      )}
    />
  );
};

export default Stack;
